export default __webpack_public_path__ + "static/advisors-5dac26dd53efad33e675a4bb70d898c4.png";